import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, FloatingLabel, Form, Alert } from "react-bootstrap";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";
import ProfilePicture from "./../../../../assets/img/default-profile.png";

const SettingsPage = () => {
    let { userData, setUserData, setLoadingState, setCanRedirectToLogin, setAlert } = useContext(ContextComponent);

    let [canRender, setCanRender] = useState(false);
    let [userInfo, setUserInfo] = useState({});
    let [profileImage, setProfileImage] = useState(ProfilePicture);

    useEffect(() => {
        if (!Utils.isObjectEmpty(userData)) {
            if (!!userData.profileImage) {
                setProfileImage(userData.profileImage || ProfilePicture);
            }
            setUserInfo(userData);
        }
    }, [userData]);

    useEffect(() => {
        if (!Utils.isObjectEmpty(userInfo)) {
            //console.log(userInfo);
            setCanRender(true);
        }
    }, [userInfo]);

    let [showProfileModal, setShowProfileModal] = useState(false);
    let [modalTitle, setModalTitle] = useState("");
    let [postfix, setPostfix] = useState("");

    const handleClose = () => {
        setShowProfileModal(false);
    };

    const openModal = (fieldsToUpdate) => {
        setShowProfileModal(true);
    };

    const allowResetPassword = (e) => {
        setModalTitle("Reset password");
        setPostfix("resetpassword");
        openModal("password");
    };

    const profileFieldChangeHandler = (e) => {
        let fieldName = e.currentTarget.id || "";
        let fieldObj = {};
        fieldObj[fieldName] = e.currentTarget.value;
    };

    let obj = {
        resetpassword: ["password", "confirmPassword"],
    };

    let [showAlert, setShowAlert] = useState(false);
    let [passwordSuccessAlertMsg, setPasswordSuccessAlertMsg] = useState("");
    let [errorMessage, setErrorMessage] = useState("");


    const handleUpdate = (e) => {
        setPasswordSuccessAlertMsg("");
        let userObjToBeSubmit = {};
        if (postfix === "resetpassword") {
            let emptyExists = false;
            let newPwd = "";
            let conNewPwd = "";
            obj[postfix].map((fieldKey, index) => {
                let pwdValue = document.querySelector("#" + fieldKey).value || "";
                index === 0 && (newPwd = pwdValue);
                index === 1 && (conNewPwd = pwdValue);
                pwdValue.trim().length === 0 && (emptyExists = true);
            });
            if (emptyExists) {
                setErrorMessage("All fields are mandatory");
                return false;
            }

            if (newPwd !== conNewPwd) {
                setErrorMessage("New password and confirm passwords are not matched.");
                return false;
            }
            setErrorMessage("");
            userObjToBeSubmit["newpassword"] = newPwd;
            userObjToBeSubmit["confirmpassword"] = conNewPwd;
        }
        setLoadingState({
            applyMask: true,
            text: "Updating Password",
        });
        const success = (response) => {
            setErrorMessage("");
            setLoadingState({
                applyMask: false,
            });
            setPasswordSuccessAlertMsg(response.data.message);
            setAlert({
                show: true,
                message: passwordSuccessAlertMsg || "password updated successfully!",
            });
            handleClose();
        };

        const fail = (err) => {
            handleClose();
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.error?.response?.data?.message ?? "Password update failed",
                type: "danger"

            });
        };
        setShowAlert(false);
        Utils.executeResetPassword(userObjToBeSubmit).then(success, fail);
    };


    return (
        <>
            <Modal centered show={showProfileModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="indi-modal-edit-user-profile-header-title">
                        {modalTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        className={`indi-modal-edit-user-profile-resetpassword-section indi-modal-edit-user-profile-${postfix}`}
                    >
                        <div>
                            <FloatingLabel
                                label="New password"
                                className="indi-modal-edit-user-profile-floating-inputs"
                            >
                                <Form.Control
                                    type="password"
                                    className="indi-input-field"
                                    id="password"
                                    placeholder="Enter new password"
                                    autoComplete="off"
                                    onChange={profileFieldChangeHandler}
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                label="Confirm password"
                                className="indi-modal-edit-user-profile-floating-inputs"
                            >
                                <Form.Control
                                    type="password"
                                    className="indi-input-field"
                                    id="confirmPassword"
                                    placeholder="Enter confirm password"
                                    autoComplete="off"
                                    onChange={profileFieldChangeHandler}
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="indi-user-profile-settings-error-msg">
                        {errorMessage}
                    </div>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary"
                        onClick={handleUpdate}
                    >
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>
            {canRender && (
                <div className="d-flex indi-user-settings-page-wrapper">
                    <div className="indi-user-settings-page-header w-100">
                        User settings page
                    </div>
                    <div className="d-flex">
                        <div className="indi-user-settings-page-account indi-user-settings-page-card">
                            <div className="indi-user-settings-page-card-header d-flex">
                                <img
                                    className="indi-user-settings-page-card-header-img"
                                    src={ProfilePicture}
                                    alt=""
                                />{" "}
                                <div className="indi-user-settings-page-card-header-label">
                                    Account
                                </div>
                            </div>
                            <div className="indi-user-settings-page-card-inner d-flex">
                                <div
                                    role="button"
                                    //onClick={allowEmailEdit}
                                    className="indi-user-settings-page-change-email d-flex indi-user-settings-page-card-inner-item"
                                >
                                    <div className="indi-user-settings-page-change-email-label">
                                        Your email ID
                                    </div>
                                    <div className="indi-user-settings-page-change-email-value">
                                        {userInfo.email}
                                    </div>
                                </div>

                                <div
                                    role="button"
                                    onClick={allowResetPassword}
                                    className="indi-user-settings-page-reset-password indi-user-settings-page-card-inner-item"
                                >
                                    Reset password
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SettingsPage;